import { CQA_QUALITY_ASSESSMENT_GRADING_SCREEN } from '../utils/isCQAGradingScreen';
import history from '../../history';

export function parseReturnToWorklistQuery(search: string): {
  projectId?: string;
  status?: string;
} {
  const params = new URLSearchParams(search);
  const projectId = params.get('projectId') ?? undefined;
  const status = params.get('status') ?? undefined;
  return { projectId, status };
}

/**
 * Augments cursorAPIContext for the CQA quality-assessment grading screen
 * opened via direct link (no navigation state). Ensures workitemId is set for submit and
 * builds returnToWorklistQuery (projectId/status) for "back to list" after submit/next.
 */
export function augmentCursorAPIContextForCQAGradingScreen(
  state: any,
  pathname: string,
  cursorAPIContext: any
): any {
  if (!pathname.startsWith(CQA_QUALITY_ASSESSMENT_GRADING_SCREEN)) {
    return cursorAPIContext;
  }

  let context = cursorAPIContext;

  // Ensure workitemId is set for PUT submit (from loaded invoices or URL path)
  const workitemId = context.workitemId;
  const hasWorkitemId = workitemId != null && String(workitemId).trim() !== '';
  if (!hasWorkitemId) {
    const sdCaseId = state?.gradeBenchPanel?.invoices?.[0]?.sdCaseId;
    if (sdCaseId != null && String(sdCaseId).trim() !== '') {
      context = { ...context, workitemId: sdCaseId };
    } else if (pathname) {
      const segments = pathname.split('/').filter(Boolean);
      const idFromPath = segments[segments.length - 1];
      if (idFromPath && idFromPath !== 'workItem') {
        context = { ...context, workitemId: idFromPath };
      }
    }
  }

  // When opened from direct link (no worklistContext or empty), build returnToWorklistQuery
  // so submit/next navigate back to list with optional projectId/status
  const isWorklistContextEmpty =
    context.worklistContext == null ||
    Object.keys(context.worklistContext).length === 0;

  if (isWorklistContextEmpty) {
    const search =
      history?.location?.search ??
      (typeof window !== 'undefined' ? window.location.search : '');
    const returnToWorklistQuery = search ? parseReturnToWorklistQuery(search) : {};
    const projectIdFromWorkItem =
      state?.gradeBenchPanel?.invoices?.[0]?.ruleCollectionId;
    if (
      returnToWorklistQuery.projectId == null &&
      projectIdFromWorkItem != null &&
      String(projectIdFromWorkItem).trim() !== ''
    ) {
      returnToWorklistQuery.projectId = projectIdFromWorkItem;
    }
    if (Object.keys(returnToWorklistQuery).length > 0) {
      context = { ...context, returnToWorklistQuery };
    }
  }

  return context;
}
